import React, { useState } from 'react';
import HidePasswordIcon from '../../../assets/HidePasswordIcon.svg';
import ShowPasswordIcon from '../../../assets/ShowPasswordIcon.svg';

const TextInput = ({
  inputRef = undefined,
  name = '',
  outterStyle = '',
  inputStyle = '',
  placeholder = '',
  value,
  handleChange,
  icon,
  iconStyle,
  type,
  maxLength = '5000',
  disabled = false,
  error,
  errorStyle,
  message,
  messageStyle,
  isOptional,
  istextArea = false,
  textAreaRow = 1,
  onFocus,
  onBlur,
  handleKeyDown = () => {},
  tabIndex,
  listID = undefined,
  autoComplete
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const InputComponent = istextArea ? 'textarea' : 'input';
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDown = () => setShowPassword(true);
  const handleMouseUp = () => setShowPassword(false);

  return (
    <>
      <div className={`relative flex flex-row ${outterStyle} items-center`}>
        {icon &&
          (typeof icon === 'string' ? (
            <img src={icon} className={`${iconStyle} mr-1.5`} alt='Icon' />
          ) : (
            <span className={`${iconStyle} mr-1.5 flex items-center`}>
              {icon}
            </span>
          ))}

        <InputComponent
          tabIndex={tabIndex}
          ref={inputRef}
          name={name}
          className={`text-neutral-800 outline-none p-2.5 text-sm  border border-transparent disabled:bg-white focus:border-neutral-200 hover:bg-neutral-100 rounded-lg w-full placeholder-black/50 ${inputStyle}`}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          type={showPassword && type === 'password' ? 'text' : type}
          onInput={(e) => {
            if (e.currentTarget.value.length >= maxLength) {
              e.currentTarget.value = e.currentTarget.value.slice(0, maxLength);
            }
          }}
          disabled={disabled}
          onFocus={() => {
            setIsFocused(true);
            onFocus && onFocus();
          }}
          onBlur={() => {
            setIsFocused(false);
            onBlur && onBlur();
          }}
          rows={textAreaRow}
          onKeyDown={handleKeyDown}
          {...(autoComplete && { autoComplete: autoComplete })}
          {...(listID && { list: listID })}
        />

        {type === 'password' && (
          <button
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onTouchStart={handleMouseDown}
            onTouchEnd={handleMouseUp}
            className='absolute right-2'
            type='button'
          >
            <img
              src={showPassword ? HidePasswordIcon : ShowPasswordIcon}
              alt='Show Password Icon'
              className='min-w-5 min-h-5'
            />
          </button>
        )}

        {isFocused && isOptional && (
          <span className='text-xs font-medium text-neutral-500 right-2 ml-2.5'>
            Optional
          </span>
        )}
      </div>

      {message && (
        <p className={`text-xs text-neutral-800 ${messageStyle}`}>{message}</p>
      )}

      {error && (
        <p className={`text-xs text-error-500 ${errorStyle}`}>{error}</p>
      )}
    </>
  );
};

export default TextInput;
